const config = {
    // httpHeadUrl: 'http://localhost:8090/ymjj',    //    API请求头地址
    httpHeadUrl: 'https://www.jtgcgj.com/ymjj',    //    API请求头地址
    pageSize: 20,
    ownerTypeObj: {
        1: '业主',
        2: '业主成员',
        3: '租户',
    },  //  住户类型
    deviceTypeObj: {
        1: '单元机',
        2: '围墙机',
    },      //  门禁类型
    deviceStatusObj: {
        1: '在线',
        2: '离线',
    },      //  设备状态
    deviceEnableObj: {
        1: '未启用',
        2: '启用',
    },      //  设备启用
    operatorObj: {
        1: '电信',
        2: '移动',
        3: '联通',
        4: '其它',
    },      //  网络运营商
    openDoorTypeObj: {
        1: '远程开门',
        2: '访问密码',
        3: '物业开门',
    },      //  开门方式
    networkingList: ['2g', '4g'],      //  联网方式
}



if (process.env.NODE_ENV === 'development') {
} else if(process.env.NODE_ENV === 'production') {
    config.httpHeadUrl = '/ymjj'
}

export default config



// WEBPACK FOOTER //
// ./src/js/config.js